module.exports = __webpack_public_path__ + "static/media/Icon feather-edit.7bac2afd.svg";